import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { ChartOfAccountStyles } from "../Chart-Of-Account/ChartOfAccountShared";
import SubCategoryForm, { typeLabel } from "./SubCategoryForm";

const Edit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [inputs, setInputs] = useState({});
  const [chartOfAccount, setChartOfAccount] = useState([]);
  const [savedAccount, setSavedAccount] = useState(null);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [subCategoryRes, chartOfAccountRes] = await Promise.all([
          Http.get("/sub-category/" + id + "/edit"),
          Http.get("/chart-of-account-code-2"),
        ]);
        const data = subCategoryRes.data;

        setInputs({
          acc_chart_of_account_id: data.acc_chart_of_account_id,
          name: data.name,
          new_name: data.new_name,
          code: data.code,
          opening_balance: data.opening_balance,
          effective_date: data.effective_date,
          remarks: data.remarks,
        });
        // Fallback label for an account the picker's list no longer offers.
        setSavedAccount(
          data.chart_of_account
            ? {
                value: data.chart_of_account.id,
                label:
                  data.chart_of_account.code +
                  " - " +
                  data.chart_of_account.name,
              }
            : null,
        );
        setChartOfAccount(chartOfAccountRes.data || []);
      } catch (e) {
        console.error("Fetch error:", e);
        setError({
          load: [
            "Could not load this sub category. Please go back and try again.",
          ],
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const accountHandleChange = (selectedOption) => {
    setInputs((values) => ({
      ...values,
      acc_chart_of_account_id: selectedOption ? selectedOption.value : "",
    }));
  };

  const displayError = (fieldName) =>
    error && error[fieldName] ? (
      <div className="text-danger small mg-t-4">{error[fieldName]}</div>
    ) : null;

  const selectedAccount =
    chartOfAccount.find(
      (option) =>
        String(option.value) === String(inputs.acc_chart_of_account_id),
    ) ||
    (savedAccount &&
    String(savedAccount.value) === String(inputs.acc_chart_of_account_id)
      ? savedAccount
      : null);

  const formSubmit = () => {
    if (saving) {
      return;
    }

    setSaving(true);
    Http.put("/sub-category/" + id, inputs)
      .then((res) => {
        navigate("/sub-category", {
          state: { message: res.data.message, type: res.data.type },
        });
      })
      .catch((e) => {
        setSaving(false);
        setError(
          e.response?.data?.errors || {
            general: [
              e.response?.data?.message ||
                "Could not update the sub category. Please try again.",
            ],
          },
        );
      });
  };

  const displayName =
    inputs.name === "new" ? inputs.new_name : typeLabel(inputs.name);

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <ChartOfAccountStyles />
        <div className="am-pagetitle">
          <div>
            <h5 className="am-title mb-1">Edit Sub Category</h5>
            <p className="text-muted mb-0 tx-12">
              {displayName || `Sub category #${id}`}
              {selectedAccount && ` · ${selectedAccount.label}`}
            </p>
          </div>
          <div className="d-flex gap-2">
            <Link
              to={`/sub-category-ledger/${id}`}
              className="btn btn-outline-secondary"
            >
              <i className="fa fa-list mg-r-6"></i>Ledger
            </Link>
            <Link to="/sub-category" className="btn btn-outline-secondary">
              <i className="fa fa-arrow-left mg-r-6"></i>Back to List
            </Link>
          </div>
        </div>

        <div className="am-pagebody">
          <div className="row">
            <div className="col-lg">
              <FormValidation error={error} />
            </div>
          </div>

          {loading ? (
            <div className="coa-panel">
              <div className="coa-empty">
                <ProgressSpinner
                  style={{ width: "42px", height: "42px" }}
                  strokeWidth="6"
                />
              </div>
            </div>
          ) : (
            <SubCategoryForm
              inputs={inputs}
              chartOfAccount={chartOfAccount}
              selectedAccount={selectedAccount}
              onChange={handleChange}
              onAccountChange={accountHandleChange}
              onSubmit={formSubmit}
              displayError={displayError}
              saving={saving}
              submitLabel="Update Sub Category"
              savingLabel="Updating..."
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Edit;
